module.exports = __webpack_public_path__ + "img/entertaining_park_big.f41b1e0d.png";